import type { ProjectItem } from '@store/reducers/dashboard/types'
import type React from 'react'

import { ProjectListRow, ProjectsNotFound } from '../ProjectsList'
import css from './styles.module.css'

interface Props {
  projects: ProjectItem[]
}

// Projects as compact rows, so that more of them fit the screen. The tiles
// are ProjectsList; the dashboard picks between the two.
export const ProjectsRows: React.FC<Props> = ({ projects }) => {
  if (!projects.length) {
    return <ProjectsNotFound />
  }

  return (
    <div className={css.projects_rows}>
      {projects.map((project) => (
        <ProjectListRow project={project} key={project.id} />
      ))}
    </div>
  )
}
